import {
  DEFAULT_MODULE_VALUE,
  DEFAULT_RUNTIME_VALUE,
  DEFAULT_SEARCH_VALUE,
  DEFAULT_STATUS_VALUE,
  DEFAULT_TIME_RANGE_VALUE,
} from '../service-map.const'

import type { ServiceMapStoreState } from './service-map.type'

export const serviceMapInitialState: ServiceMapStoreState = {
  timeRangeValue: DEFAULT_TIME_RANGE_VALUE,
  customRangeApplied: null,
  runtimeValue: DEFAULT_RUNTIME_VALUE,
  moduleValue: DEFAULT_MODULE_VALUE,
  searchValue: DEFAULT_SEARCH_VALUE,
  statusValue: DEFAULT_STATUS_VALUE,
}
